export default __webpack_public_path__ + "static/media/debit-card.5b55b34a.svg";